import { Box, Button} from '@mui/material'
import { Link, useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { saveDetail, signupUserSelector } from '@store/slices/auth.slice';
import { BusinessProfile } from '@shared/components/BusinessProfile';
import { Business } from '@interfaces/register';

export const RegisterBusinessProfile = () => {
    const history = useHistory();
    const dispatch = useAppDispatch();
    const user = useAppSelector(signupUserSelector)

    const onSubmit = (data: any) => {
        delete data.cover_updated;
        delete data.logo_updated;
        dispatch(saveDetail({ business: { ...user.business, ...data } }));
        history.push('/auth/signup/notifications');
    }

    return (
        <Box sx={{ minWidth: { md: '600px' } }}>
            <BusinessProfile profile={user.business as Business} submit={onSubmit}>
                <Box width={1} py={2} className="flex-justify-center" sx={{ flexDirection: { xs: 'column', md: 'row-reverse' } }}>
                    <Button variant="contained" className="w-100" color="primary" type="submit">
                        Continue
                    </Button>&nbsp;&nbsp;
                    <Button color="primary" variant="outlined" className="w-100" component={Link} to={`/auth/signup/phone`}>
                        Back
                    </Button>
                </Box>
            </BusinessProfile>
        </Box>
    )
}
